// Importar la función para detectar sitios europeos
import { isEuropeanDomain } from './urls'

const soundS3Url = 'https://assets-europa.s3.eu-west-1.amazonaws.com/admin/sounds'

/** Play a sound from url */
export const playSound = (src: string, loop = false) => {
    const sound = new Audio(src)
    sound.loop = loop
    sound.addEventListener('canplaythrough', sound.play)
}

// Enumeración de nombres de archivos de sonido (sin rutas)
export enum SOUNDS {
    SILENT = 'silence.mp3',
    DEFAULT = 'default.mp3',
}

export const getSoundUrl = async (soundFileName: SOUNDS): Promise<string> => {
    const isEuropean = isEuropeanDomain()

    if (isEuropean) {
        return `${soundS3Url}/${soundFileName}`
    }

    // Para dominios no europeos, usar la ruta local
    return `/sounds/${soundFileName}`
}

/**
 * Reproduce un sonido utilizando la ruta correcta según la región
 * @param sound Sonido a reproducir (de la enumeración SOUNDS)
 * @param loop Si el sonido debe repetirse en bucle
 */
export const playSoundByName = async (sound: SOUNDS, loop = false) => {
    try {
        const soundUrl = await getSoundUrl(sound)
        playSound(soundUrl, loop)
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error playing sound with signed URL:', error)
        // Fallback a la ruta local en caso de error
        playSound(`/sounds/${sound}`, loop)
    }
}
